import React, { useContext, useState } from "react";
import { Button } from "@livechat/design-system";
import styled from '@emotion/styled';
import { ChatContext } from "../../context/chat";
import { getToken, closeChatById } from "../../utils/chat-sdk";
import { AiOutlineClose } from "react-icons/ai";
import { IconContext } from "react-icons";
import { setBotStore, setMsgNumStore, setBotMsgNumStore, clearStore } from "../../utils/store";
import { RadioButton } from "@livechat/design-system";
import { SearchBar } from "@livechat/design-system";
import { AiFillCloseCircle } from "react-icons/ai";
import { getMsgByTrans } from "../../utils/constants";
import img001 from '../../assets/icon/img001.png';
import tg from '../../assets/tg.png';
import messenger from '../../assets/messenger.png';
const List = styled.div`
  padding: 25px 0 13px 9px;
  width: 350px;
  z-index:10;
  border-right: 0px solid ${({ theme }) => theme.secondary};
  border-radius:8px;
  position: relative;
  box-sizing: border-box;
  > button {
    margin-bottom: 0.7rem;
  }
`;
const ListScrollbar = styled.div`
  width:365px;
  height:calc(100vh - 180px );
  direction: rtl;
  position:relative;
  overflow-y: auto;
  overflow-x:hidden;
  padding:0 0px 0 8px;
`;
const ListBox = styled.div`
  min-height:calc(100vh - 180px );
  direction: initial;
  // background:#f5f6f8;
  // border-radius: 8px;
  padding:5px;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  width: 365px;
  overflow-x: hidden;
`;
const ListFixedTotle = styled.div`
  direction: initial;
  color:#fff;
  height:24px;
  line-height:24px;
  font-size:14px;
  text-align:center;
  background:#56d7d2;
  width:341px;
  position: absolute;
  bottom:44px;
  right:0;
  cursor:pointer;
  `;
const ListFixedSort = styled.div`
  direction: initial;
  color:#858585;
  background:#e2e5eb;
  height:44px;
  width:341px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  position: absolute;
  bottom:0;
  right:0;
  display:flex;
  justify-content: center;
  font-size:14px;
  .lc-field-description{white-space: nowrap; margin:0 0 0 0 !important;}
  .lc-radio{ display:flex;align-items: center; padding:0 30px;}
  .lc-radio__inner-circle{ background:#56d7d2 !important;}
  .lc-radio--selected .lc-radio__circle{border-color: #56d7d2 !important;}
  `;
const ListFixedTotleIcon = styled.span`
  display:inline-block; width:14px; height:12px; margin-right:10px; background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAMAAABlXnzoAAAAP1BMVEVMaXH////////////////////////////////////////////////////////////////////////////////u4+wCAAAAFHRSTlMAP62ywLmfOyYqV72kyKcSD4eCOJZ4ouYAAABSSURBVHjaPctZDoAwDAPRoQuFlp3c/6xEVsT8PVkm20K0WoIqSxWvuKWCGm7XELRfZ2wpg//1y4luM7DvwGYdJrc6rMHvTQr79gryc2uLmsX2AS3WA3AP3fggAAAAAElFTkSuQmCC') no-repeat 0 0; background-size:100% 100%;
`;
const ListSearch = styled.div`
width: 333px;
padding: 8px 10px 4px 12px;
border-radius: 8px;
  .lc-search-bar__container{
    background:#e2e7eb;
    border-radius:8px;
    font-size:14px; 
    color:#b0bac4;
    height:38px;
  }
  .lc-search-bar__input{ border:0 !important; background:#e2e7eb !important;border-radius:8px;}
`;

const ChatList = () => {
  const { chatList, fetchMessages, activeChat, setChatList, sendMessage, sysTags } = useContext(ChatContext)
  const groups = [
    { cid: "e78b90514ad499a0532730690f1676e8", groupid: 0, groupname: "vn777", color: '#04aa33' },
    { cid: "e78b90514ad499a0532730690f1676e8", groupid: 1, groupname: "vn888", color: 'red' },
    { cid: "8096fbe76bb37fa89550d76bdee483cf", groupid: 0, groupname: "vn777", color: '#04aa33' },
    { cid: "8096fbe76bb37fa89550d76bdee483cf", groupid: 1, groupname: "vn888", color: 'red' }
  ]

  const getThreadId = (chat) => {
    if (chat?.last_thread_summary) {
      return `${chat.last_thread_summary.id}`
    }

    return `${chat?.thread.id}`
  }

  const markAsNoBot = (chat) => {
    const newChats = [...(chatList || [])];

    const chatToChange = chatList?.find(item => item.id === chat.id);

    if (chatToChange) {
      setBotStore(chatToChange.id, !chatToChange.noBot ? "1" : "0")
      chatToChange.noBot = !chatToChange.noBot;
      chatToChange.needAdmin = false;
    }

    setChatList(newChats);
  }

  const clearNum = (chatid) => {
    const chatToChange = chatList?.find(item => item.id === chatid);
    if (chatToChange) {
      setMsgNumStore(chatToChange.id, 0)
      setBotMsgNumStore(chatToChange.id, 0)
      chatToChange.msgNum = 0;
      chatToChange.botMsgNum = 0;
      chatToChange.needAdmin = false;
    }

    const newChats = [...(chatList || [])];
    setChatList(newChats);
  }
  const getTagColor = (tag) => {
    var color = "#000";
    const itemTag = sysTags?.find(item => item.tag === tag);
    if (itemTag && itemTag.color) {
      color = itemTag.color
    }
    return color

  }
  const getGroupName = (groupId) => {
    const g_item = groups.find(item => item.cid === process.env.REACT_APP_CLIENT_ID && item.groupid == groupId);
    return g_item?.groupname || ''

  }
  const getGroupColor = (groupId) => {
    const g_item = groups.find(item => item.cid === process.env.REACT_APP_CLIENT_ID && item.groupid == groupId);
    return g_item?.color || ''

  }
  const closeChat = (chatId) => {

    if (window.confirm('Are you sure you want to terminate the chat?')) {

      sendMessage(chatId, getMsgByTrans("endchat"));
      setTimeout(function () {
        if (closeChatById(chatId)) {
          setMsgNumStore(chatId, 0)
          setBotMsgNumStore(chatId, 0)

          if (activeChat?.id == chatId) {
            const chatToChange = chatList?.filter(item => {
              return item.id != chatId
            });

            if (chatToChange) {

              fetchMessages(chatToChange[0])
            } else {
              fetchMessages(null)
            }
          }
          clearStore(chatId)
        }
        return true;
      }, 100)


    } else {
      //alert("取消");
      return false;
    }


  }
  const [searchValue, setSearchValue] = useState("");
  const SearchBarChange = (value) => {
    // console.log('SearchBarChange==>', value);
    setSearchValue(value);
  }
  return (
    <List>
      <div className="list-box-bg"></div>
      <p className="list-numbers">My chats({chatList ? chatList.length : 0})</p>
      <ListSearch><SearchBar placeholder="search the guest name..." onChange={SearchBarChange} /></ListSearch>
      <ListScrollbar>

        <ListBox>
          {/* <ListFixedTotle>
            <ListFixedTotleIcon></ListFixedTotleIcon>25条新消息
          </ListFixedTotle>
          <ListFixedSort>
            <RadioButton checked="true" description="默认排序" />
            <RadioButton checked="false" description="未回复排序" />
          </ListFixedSort> */}
          {chatList?.filter(r => { return r.pin }).sort((a, b) => new Date(b.lastDate) - new Date(a.lastDate)).map((chatItem) => {
            const groupid = chatItem.access?.group_ids[0] || 0;
            const chatId = getThreadId(chatItem)
            const isActive = chatId === getThreadId(activeChat)
            const buttonType = isActive ? 'primary' : 'secondary'
            const customer = chatItem.users.find(({ type }) => type === 'customer')
            const client_id = chatItem.properties.source?.client_id;
            const conversation_link = client_id ? chatItem.properties[client_id]?.conversation_link : null;
            var pluginImg = conversation_link ? (conversation_link.indexOf("facebook.com") >= 0 ? "1" : "") : "";
            if (pluginImg != "1") {

              if (customer.session_fields && customer.session_fields.some(item => item.hasOwnProperty('telegram_id'))) {
                pluginImg = "2";
              }
              if (customer?.avatar && customer?.avatar.indexOf("telegram") && customer?.avatar.indexOf("account_id")) {
                pluginImg = "2";
              }
            }
            const typeColor = chatItem.userType ? "list-up" + chatItem.userType : "";
            return (
              <div className={isActive ? 'list list-select ' + typeColor : 'list ' + typeColor} style={{ display: customer?.name?.toLowerCase().indexOf(searchValue) >= 0 ? 'block' : 'none' }}>
                <div key={'user' + chatId} onClick={() => { fetchMessages(chatItem); clearNum(chatItem.id) }}
                  kind={buttonType}
                  className="list-box">
                  <div className="list-img">
                    <img src={img001} />
                    <span className={chatItem.is_followed ? "active online" : "active"}></span>
                  </div>

                  <div className="list-name">
                    <div className="list-name-item">
                      <p className="list-name-value">
                        {customer?.name || 'customer'}
                        <img style={{ width: '20px', height: '20px', marginLeft: '6px', display: pluginImg == '1' ? 'block' : 'none' }} src={messenger} />
                        <img style={{ width: '20px', height: '20px', marginLeft: '6px', display: pluginImg == '2' ? 'block' : 'none' }} src={tg} />
                      </p>
                      <p className="list-name-time">
                        {/* <span className="icon-unread"></span>
                        <span className="icon-read"></span> */}
                        {/* chatItem.last_event_per_type?.message?.thread_created_at */}
                        {chatItem.lastDate ? new Date(chatItem.lastDate).toLocaleString() : chatItem.thread ? new Date(chatItem.thread?.created_at || '').toLocaleString() : ''}

                      </p>
                      {(chatItem.last_thread_summary?.active || chatItem.thread?.active) &&
                        <div className="list-del" onClick={() => closeChat(chatItem.id)}><AiFillCloseCircle /></div>}
                    </div>
                    <div className="list-name-item" style={{ 'align-items': 'end' }}>
                      <p className="list-name-msg">{chatItem.lastText}</p>

                      {chatItem.msgNum > 0 && <p className="list-name-msg-num">{chatItem.msgNum}</p>}
                      {chatItem.botMsgNum > 0 && <p className="list-name-msg-num-bot">{chatItem.botMsgNum}</p>}
                      {/* <p className="list-name-msg-num">2</p> 未读数量 */}
                    </div>
                    <div className="list-name-item list-tips" style={{ 'justify-content': 'start' }}>
                      <span style={{ 'background': getGroupColor(groupid) }}>{getGroupName(groupid)}</span>
                      {chatItem.tags?.map((itemTag) => {
                        return (<span style={{ 'background': getTagColor(itemTag) }}>{itemTag}</span>)
                      })}
                    </div>
                  </div>
                </div>
                {chatItem.needAdmin && <div className="list-rengong ani-shake"><span className="icon-rengong-small"></span>call admin</div>}
                {!chatItem.needAdmin && chatItem.noBot && <div className="list-rengonging "><span className="icon-msg-rengong"></span></div>}
              </div>
            );
          })}

          <div className="line-fg"></div>
          {chatList?.filter(r => { return !r.pin && !r.upChat }).sort((a, b) => new Date(b.lastDate) - new Date(a.lastDate)).map((chatItem) => {
            const groupid = chatItem.access?.group_ids[0] || 0;
            const chatId = getThreadId(chatItem)
            const isActive = chatId === getThreadId(activeChat)
            const buttonType = isActive ? 'primary' : 'secondary'
            const customer = chatItem.users.find(({ type }) => type === 'customer')
            const client_id = chatItem.properties.source?.client_id;
            const conversation_link = client_id ? chatItem.properties[client_id]?.conversation_link : null;
            var pluginImg = conversation_link ? (conversation_link.indexOf("facebook.com") >= 0 ? "1" : "") : "";
            if (pluginImg != "1") {

              if (customer.session_fields && customer.session_fields?.some(item => item.hasOwnProperty('telegram_id'))) {
                pluginImg = "2";
              }
              if (customer?.avatar && customer?.avatar.indexOf("telegram") && customer?.avatar.indexOf("account_id")) {
                pluginImg = "2";
              }
            }
            return (
              <div className={isActive ? 'list list-select ' : 'list '} style={{ display: customer?.name?.toLowerCase().indexOf(searchValue) >= 0 ? 'block' : 'none' }}>
                <div key={'user' + chatId} onClick={() => { fetchMessages(chatItem); clearNum(chatItem.id) }}
                  kind={buttonType}
                  className="list-box">
                  <div className="list-img">
                    <img src={img001} />
                    <span className={chatItem.is_followed ? "active online" : "active"}></span>
                  </div>

                  <div className="list-name">
                    <div className="list-name-item">
                      <p className="list-name-value">
                        {customer?.name || 'customer'}
                        <img style={{ width: '20px', height: '20px', marginLeft: '6px', display: pluginImg == '1' ? 'block' : 'none' }} src={messenger} />
                        <img style={{ width: '20px', height: '20px', marginLeft: '6px', display: pluginImg == '2' ? 'block' : 'none' }} src={tg} />
                      </p>
                      <p className="list-name-time">
                        {/* <span className="icon-unread"></span>
                        <span className="icon-read"></span> */}
                        {/* chatItem.last_event_per_type?.message?.thread_created_at */}
                        {chatItem.lastDate ? new Date(chatItem.lastDate).toLocaleString() : chatItem.thread ? new Date(chatItem.thread?.created_at || '').toLocaleString() : ''}

                      </p>
                      {(chatItem.last_thread_summary?.active || chatItem.thread?.active) &&
                        <div className="list-del" onClick={() => closeChat(chatItem.id)}><AiFillCloseCircle /></div>}
                    </div>
                    <div className="list-name-item" style={{ 'align-items': 'end' }}>
                      <p className="list-name-msg">{chatItem.lastText}</p>

                      {chatItem.msgNum > 0 && <p className="list-name-msg-num">{chatItem.msgNum}</p>}
                      {chatItem.botMsgNum > 0 && <p className="list-name-msg-num-bot">{chatItem.botMsgNum}</p>}
                      {/* <p className="list-name-msg-num">2</p> 未读数量 */}
                    </div>

                    <div className="list-name-item list-tips" style={{ 'justify-content': 'start' }}>
                      <span style={{ 'background': getGroupColor(groupid) }}>{getGroupName(groupid)}</span>
                      {chatItem.tags?.map((itemTag) => {
                        return (<span style={{ 'background': getTagColor(itemTag) }}>{itemTag}</span>)
                      })}
                    </div>

                  </div>
                </div>
                {chatItem.needAdmin && <div className="list-rengong ani-shake"><span className="icon-rengong-small"></span>call admin</div>}
                {!chatItem.needAdmin && chatItem.noBot && <div className="list-rengonging "><span className="icon-msg-rengong"></span></div>}
              </div>
            );
          })}
        </ListBox>
      </ListScrollbar>
    </List>
  )
};

export default ChatList;
